export const crossIcon =
  'https://dom-content-vault-prod-cdn-assets.porter.in/cross_icon_grey_a85a70f29a/cross_icon_grey_a85a70f29a.svg';

export const modalCloseCrossIcon =
  'https://dom-content-vault-prod-cdn-assets.porter.in/cross_icon_29cf70155f/cross_icon_29cf70155f.svg';
